import React, { useState } from 'react';
import {
  experience1,
  experience2,
  experience3,
  flag1,
  flag2,
  flag3,
  flag4,
  flag5,
  flag6,
  flag7,
  flag8,
  flag9,
  gallery1,
  gallery10,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  gallery7,
  gallery8,
  gallery9,
  globe,
  okay,
  partners1,
  partners2,
  partners3,
  partners4,
  partners5
} from '../../assets/images';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';


const Experience = () => {
  const { t } = useTranslation();
    const [activeIndex, setActiveIndex] = useState(0);
    const [showText, setShowText] = useState(false);
    const [showButton, setShowButton] = useState(false);
      

        const flags = [
    { id: 1, image: gallery1 },
    { id: 2, image: gallery2 },
    { id: 3, image: gallery3 },
    { id: 4, image: gallery4 },
    { id: 5, image: gallery5 },
    { id: 6, image: gallery6 },
    { id: 7, image: gallery7 },
  ];

   const videos = [
    { id: 1, image: gallery8 },
    { id: 2, image: gallery9 },
    { id: 3, image: gallery10 }
  ];

    const [activeTab, setActiveTab] = useState("photos"); // photos | videos




       const navigate = useNavigate()
      
        const [clientName, setclientName] = useState("");
         const [clientSurname, setclientSurname] = useState("");
        const [clientEmail, setclientEmail] = useState("");
         const [clientCountry, setclientCountry] = useState("");
         const [clientProfession, setclientProfession] = useState("");
         const [clientCv, setclientCv] = useState("");
        const [clientPhone, setclientPhone] = useState("");
        const [clientMessage, setclientMessage] = useState("");
      
      
        const handleSubmitContact = async (e) => {
          e.preventDefault();
        
          let inputs = { name: clientName, email: clientEmail, phone: clientPhone, message: clientMessage };
          
          try {
            console.log(inputs);
            
            // Seçilen ürünleri post isteği ile gönder
            const response = await axios.post("https://www.tanura.az/tanura/contact.php/", inputs);
            
            // Başarılı olduğunda yapılacak işlemler
            toast.success("Form göndərildi");
            
            // Clear form after successful submission
            setclientName('');
            setclientEmail('');
            setclientPhone('');
            setclientMessage('');
            
            navigate('/');
            
          } catch (error) {
            // Hata durumunda yapılacak işlemler
            console.error("Sipariş gönderilirken bir hata oluştu:", error);
            toast.error("Form göndərilərkən xəta baş verdi");
          }
        };



  return (

   <>
     <div className="md:max-w-container max-w-containerSm mx-auto mt-[24px] md:mt-[56px]">
          <p >{t("Ana səhifə")} <i className={`fas fa-chevron-right text-[black] ml-3 mr-3`}/> {t("Təcrübə proqramı")}</p>
          <div>
          <div className="max-w-container mx-auto mt-[24px] md:mt-[56px] ">
      <div className='md:flex justify-between'>
     <div className='bg-white rounded-[24px] py-4 px-6 md:w-[650px]'>
   <p className='text-[30px] font-medium'>{t("Azərbaycanda Beynəlxalq Təcrübə Proqramı (Bakı)")}</p>
   <p className='text-[20px] mt-4'>{t("Dünyanın hər yerindən həkimlər Azərbaycanda professional təcrübə qazanmaq üçün bizə müraciət edə bilərlər. Proqram müddəti tamamilə sərbəstdir, ən azı 1 həftədən başlayaraq, 3-4 ay və ya daha uzun müddət seçə bilərsiniz.")}</p>  <br/>
   <p className='text-[20px]'>{t("Bizim Təcrübə proqramı paketi hər şey daxil konseptdə hazırlanıb və gələn hər bir iştirakçı üçün maksimum rahatlıq təmin edir.")}</p>
     </div>
     <div className='md:w-[590px] mt-4 md:mt-0'>
      <img src={experience1}></img>
     </div>
      </div>
        <div className='flex flex-col-reverse md:flex-row justify-between mt-[64px] md:mt-[104px]'>
               <div className='md:w-[470px] mt-[55px] md:mt-0'>
      <img src={experience2}></img>
     </div>
     <div className='bg-white rounded-[24px] py-4 px-6 md:w-[750px]'>
   <p className='text-[30px] font-medium'>{t("Paketə daxildir")}</p>
<div className='flex items-center gap-3 mt-6'>
  <img className='w-6 h-6' src={okay}></img>
     <p className='text-[20px]'>{t("Hava limanından xüsusi qarşılama və otelə transfer")}</p>
</div>
<div className='flex items-center gap-3 mt-3'>
  <img className='w-6 h-6' src={okay}></img>
     <p className='text-[20px]'>{t("Otel gecələmələri (qaldığınız bütün müddət ərzində, səhər yeməyi daxil)")}</p>
</div>
<div className='flex items-center gap-3 mt-3'>
  <img className='w-6 h-6' src={okay}></img>
     <p className='text-[20px]'>{t("7/24 dəstək xidməti")}</p>
</div>
<div className='flex items-center gap-3 mt-3'>
  <img className='w-6 h-6' src={okay}></img>
     <p className='text-[20px]'>{t("Ən prestijli həkimlərlə və qabaqcıl xəstəxanalarda praktika + hər gün nahar yeməyi")}</p>
</div>
<div className='flex items-center gap-3 mt-3'>
  <img className='w-6 h-6' src={okay}></img>
     <p className='text-[20px]'>{t("Həftənin bir günü Bakı şəhər turu + Direktorumuz  Fatimə xanımla milli restoranda şam yeməyi")}</p>
</div>
<div className='flex items-center gap-3 mt-3'>
  <img className='w-6 h-6' src={okay}></img>
     <p className='text-[20px]'>{t("Təlimin sonunda: Sertifikat mərasimi (Direktor Fatimə xanım və təlimçi həkimlə birlikdə) və rəsmi sertifikat")}</p>
</div>
<div className='flex items-center gap-3 mt-3'>
  <img className='w-6 h-6' src={okay}></img>
     <p className='text-[20px]'>{t("Bitirdikdə: Otel → Hava limanı xüsusi transferi")}</p>
</div>
     </div>
      </div>
    </div>
          </div>
         
        </div>

    <div className="md:max-w-container md:mt-[104px] mt-[64px] max-w-containerSm mx-auto">
  <p className="text-black text-[30px] font-medium text-center mb-8 md:mb-0">
    {t("Qalereya")}
  </p>

  {/* Tabs */}
  <div className="flex justify-center mt-8 space-x-8">
    <button
      onClick={() => setActiveTab("photos")}
      className={`text-lg font-medium px-5 py-2 rounded-[12px] text-[28px] ${
        activeTab === "photos"
          ? "text-[white] bg-[#388E3C]"
          : "border-transparent text-[#0E0E0E]"
      }`}
    >
      {t("şəkillər")}
    </button>
    <button
      onClick={() => setActiveTab("videos")}
      className={`text-lg font-medium px-5 py-2 rounded-[12px] text-[28px] ${
        activeTab === "videos"
          ? "text-[white] bg-[#388E3C]"
          : "border-transparent text-[#0E0E0E]"
      }`}
    >
      {t("videolar")}
    </button>
  </div>

  {/* Slider */}
  <div className="block mt-[56px]">
    <Swiper
      spaceBetween={20}
      loop={true}
      autoplay={{
        delay: 4000,
        disableOnInteraction: false,
      }}
      navigation={true}
      modules={[Autoplay, Pagination, Navigation]}
      className="mySwiper"
      breakpoints={{
        0: {
          slidesPerView: 1,
        },
        640: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
        1280: {
          slidesPerView: 5,
        },
      }} 
    > 
      {activeTab === "photos"
        ? flags.map((flag, index) => (
            <SwiperSlide key={flag.id}>
              <img
                className="h-auto md:h-[267px] w-full md:w-[236px] object-cover rounded-xl"
                src={flag.image}
                alt={`Flag ${index + 1}`}
              />
            </SwiperSlide>
          ))
        : videos.map((video, index) => (
            <SwiperSlide key={video.id}>
              <video
                className="h-auto md:h-[267px] w-full md:w-[236px]  rounded-xl object-cover"
                controls
                src={video.image}
              />
            </SwiperSlide>
          ))}
    </Swiper>
  </div>
</div>


         <div className="md:max-w-container max-w-containerSm mx-auto mt-[64px] md:mt-[104px]">
          <div className='flex flex-col-reverse md:flex-row justify-between'>
          <div className='mt-8 md:mt-0'> 
             <img className='w-[479px] h-[412px]  md:h-[433px]' src={experience3}></img>
           </div>
           <div className='md:w-[745px] md:h-[433px] md:mt-0 bg-[white] rounded-[24px] px-6 py-4 box-border'>
             <p className='text-3xl md:text-[28px] font-medium'>{t("Siz də Azərbaycanda unudulmaz tibbi təcrübə yaşamaq istəyirsinizsə, indi müraciət edin !")} </p>
             <form onSubmit={handleSubmitContact} className='md:mt-6'>
             <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
             <div>
               <input
               onChange={(event) => setclientName(event.target.value)}
               value={clientName}
               required 
                placeholder={t("Ad *")} type="text" id="name" class="bg-[white] border border-neutral-200 mt-2 block w-full  rounded-[5px] h-[53px] focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm pl-3 pr-3" />
       
             </div>
       
           
             <div>
               <input  onChange={(event) => setclientSurname(event.target.value)}
               value={clientSurname}
                required placeholder={t("Soyad *")} type="text" id="surname" class="bg-[white] border border-neutral-200 mt-2 block w-full  rounded-[5px] h-[53px] focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm pl-3 pr-3" ></input>
             </div>
       
             <div>
               <input onChange={(event) => setclientCountry(event.target.value)}
             value={clientCountry}
             required placeholder={t("Ölkə *")} type="text" id="country" class="bg-[white] border border-neutral-200 mt-2 block w-full  rounded-[5px] h-[53px] focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm pl-3 pr-3"></input>
             </div>
             <div>
               <input onChange={(event) => setclientProfession(event.target.value)}
             value={clientProfession}
             required placeholder={t("İxtisas *")} type="text" id="profession" class="bg-[white] border border-neutral-200 mt-2 block w-full  rounded-[5px] h-[53px] focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm pl-3 pr-3"></input>
             </div>
                <div>
               <input onChange={(event) => setclientEmail(event.target.value)}
             value={clientEmail}
             required placeholder={t("E-mail *")} type="email" id="email" class="bg-[white] border border-neutral-200 mt-2 block w-full  rounded-[5px] h-[53px] focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm pl-3 pr-3"></input>
             </div>
             <div>
               <input onChange={(event) => setclientCv(event.target.value)}
             value={clientCv}
             required placeholder={t("CV *")} type="text" id="cv" class="bg-[white] border border-neutral-200 mt-2 block w-full  rounded-[5px] h-[53px] focus:outline-none focus:ring-gray-500 focus:border-gray-500 sm:text-sm pl-3 pr-3"></input>
             </div>
             </div>
       
        
           <div class="flex justify-end">
             <button type="submit" class="w-[148px] h-10 p-2.5 bg-[#FB8C00] rounded-xl justify-center items-center mt-6 gap-2.5 inline-flex text-[white]">{t("Göndər")}</button>
           </div>
         </form>
           </div>
          </div>
         </div>
   </>
  );
};

export default Experience;